import { AssignmentInfo, TravelInfo, Wrapper } from "components";
import { HeaderWithBack } from "components/HeaderBack";
import { useNavigate, useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getTripRequest } from "services/trip-request";
import { RootState } from "store";
import styles from "./styles.module.scss";

export default function CanceledTravelPage() {
	const navigate = useNavigate();

	const { logged_user } = useSelector((state: RootState) => state.tokens);

	const { tripId } = useParams();
	const [trip, setTrip] = useState<any>({});
	const [tripDeparture, setTripDeparture] = useState("");
	const [tripArrival, setTripArrival] = useState("");

	const fetchData = async () => {
		if (!logged_user) return;

		getTripRequest(tripId)
			.then((apiTrip: any) => {
				setTrip(apiTrip);

				if (apiTrip.status !== "cancelled") {
					navigate("/viagens");
					return;
				}

				const departureTrip = apiTrip?.points?.find(
					(point: any) => point.direction === "going" && point.type === "origin"
				);
				setTripDeparture(departureTrip.city);

				const arrivalTrip = apiTrip?.points?.find(
					(point: any) =>
						point.direction === "going" && point.type === "destination"
				);
				setTripArrival(arrivalTrip.city);
			})
			.catch((error) => {
				const message =
					"Algo saiu errado ao buscar os dados da viagem. Entre em contato com o suporte.";

				toast.error(message, {
					position: "bottom-center",
					autoClose: 5000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "light"
				});

				navigate("/viagens");
			});
	};

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<div className={styles.container}>
			<HeaderWithBack
				label={`${tripDeparture} → ${tripArrival}`}
				backTo={-1}
				className={styles.header}
			/>
			<Wrapper>
				<TravelInfo trip={trip} />

				<div className={styles.travelAssignment}>
					<span>Veículo e Motorista</span>
					<AssignmentInfo
						vehicle={trip.trip_response?.chosen_vehicle}
						driver={trip.trip_response?.chosen_driver}
					/>
				</div>

				<div className={styles.card}>
					<span>Viagem cancelada</span>
					<span>
						A viagem foi cancelada. Nenhum valor foi repassado e o veículo e
						motorista estão liberados.
					</span>
				</div>
			</Wrapper>
		</div>
	);
}
